import { TravellerMembershipDTO } from '@/api/trafikportalen';
import {
  formatScheduledInactivation,
  getMembershipStatus,
} from '@/helpers/membershipStatus';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  IconCheckCircle,
  IconXMarkCircle,
  IconExclamationTriangle,
} from '@/icons';

interface MembershipStatusBadgeProps {
  membership: TravellerMembershipDTO;
}

export const MembershipStatusBadge = ({
  membership,
}: MembershipStatusBadgeProps) => {
  const { formatMessage } = useIntl();
  const status = getMembershipStatus(membership);

  if (status === 'inactive') {
    return (
      <div className="flex w-fit items-center gap-1 rounded-full bg-background-400 px-2 py-0.5 text-sm text-text-800">
        <IconXMarkCircle className="size-4" aria-hidden="true" />
        <FormattedMessage defaultMessage="Inaktiv" />
      </div>
    );
  }

  if (status === 'will-inactivate' || status === 'pending-inactivation') {
    return (
      <div className="flex w-fit items-center gap-1 rounded-full bg-yellow-500 px-2 py-0.5 text-sm text-contrast-yellow">
        <IconExclamationTriangle className="size-4" aria-hidden="true" />
        {formatScheduledInactivation(formatMessage, membership.inactivate_at)}
      </div>
    );
  }

  return (
    <div className="flex w-fit items-center gap-1 rounded-full bg-green-500 px-2 py-0.5 text-sm text-contrast-green">
      <IconCheckCircle className="size-4" aria-hidden="true" />
      <FormattedMessage defaultMessage="Aktiv" />
    </div>
  );
};
